import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { EmailSentComponent } from './email-sent/email-sent.component';
import { VerifyTokenComponent } from './verify-token/verify-token.component';
import { AnswerComponent } from './security-question/answer/answer.component';
import { UpdateComponent } from './security-question/update/update.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ExpiredPasswordComponent } from './expired-password/expired-password.component';
import { UnlockAccountComponent } from './unlock-account/unlock-account.component';
import { OktaRoutes } from '../../core/constants/routes.constant';
import { UnauthGuard } from '../../core/guards/unauth.guard';
import { AuthGuard } from '../../core/guards/auth.guard';

const oktaRoutes: Routes = [
  {
    path: OktaRoutes.ForgotPassword,
    component: ForgotPasswordComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: OktaRoutes.ForgotPassword + '/:token',
    component: ForgotPasswordComponent
  },
  { path: OktaRoutes.ResetPassword, component: ResetPasswordComponent },
  {
    path: OktaRoutes.ChangePassword,
    component: ChangePasswordComponent
  },
  {
    path: OktaRoutes.UpdateSecurityQuestion,
    component: UpdateComponent,
    canActivate: [AuthGuard]
  },
  { path: OktaRoutes.AnswerSecurityQuestion, component: AnswerComponent },
  {
    path: OktaRoutes.Register + '/:token',
    component: ActivateUserComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: OktaRoutes.ActivateUser,
    component: ActivateUserComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: OktaRoutes.PasswordExpired,
    component: ExpiredPasswordComponent
  },
  {
    path: OktaRoutes.EmailSent,
    component: EmailSentComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: OktaRoutes.ResetPwd + '/:token',
    component: ActivateUserComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: OktaRoutes.ResetPwd,
    component: ActivateUserComponent,
    canActivate: [UnauthGuard]
  },
  { path: OktaRoutes.VerifyToken, component: VerifyTokenComponent }
];

@NgModule({
  imports: [RouterModule.forChild(oktaRoutes)],
  exports: [RouterModule]
})
export class OktaRoutingModule {}
